import { LuFilter, LuKanban, LuList } from 'react-icons/lu';

import { Button } from '@/components/ui/button';

import { OpportunityLayout, useOpportunityViewState } from '../opportunity-state';

export const OpportunityLayoutTabs = () => {
    const { opportunityViewState, setOpportunityViewState } = useOpportunityViewState();
    return (
        <div className="border-border flex overflow-hidden rounded-full border bg-white">
            <Button
                variant={opportunityViewState.layout === OpportunityLayout.LIST ? 'highlighted' : 'ghost2'}
                size="sm"
                className="rounded-none rounded-l-full border-0"
                onClick={() => setOpportunityViewState({ layout: OpportunityLayout.LIST })}
            >
                <LuList className="h-4 w-4" />
                List
            </Button>
            <Button
                variant={opportunityViewState.layout === OpportunityLayout.KANBAN ? 'highlighted' : 'ghost2'}
                size="sm"
                className="rounded-none border-0"
                onClick={() => setOpportunityViewState({ layout: OpportunityLayout.KANBAN })}
            >
                <LuKanban className="h-4 w-4" />
                Kanban
            </Button>
            <Button
                variant={opportunityViewState.layout === OpportunityLayout.FUNNEL ? 'highlighted' : 'ghost2'}
                size="sm"
                className="rounded-none rounded-r-full border-0"
                onClick={() => setOpportunityViewState({ layout: OpportunityLayout.FUNNEL })}
            >
                <LuFilter className="h-4 w-4" />
                Funnel
            </Button>
        </div>
    );
};
